import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup ,FormControl, Validators} from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'educational',
  template: `
  <style>
  .mat-form-field--inline {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .mat-form-field--inline .mat-form-field {
        display: inline-block;
        width: 100%;
        vertical-align: middle;
    }

    .mat-form-field--inline .mat-form-field:nth-child(1) {
        margin-right: 10px;
    }
    
    @media (max-width: 767px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 1200px) {
      #selectLine{  
        width: 145%;
      } 
    }
      
    @media (min-width: 768px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 992px) {
      #selectLine{  
        width: 145%;
      } 
    }

    .example-full-width {
      
    }
  </style>
  <nb-card status="success"  [style.height.px]="630" [style.overflow]="'auto'">
    <nb-card-header>Add Educational Details</nb-card-header>
    <nb-card-body> 
      <span *ngIf="instructionValidation===false" style="color:red;">Please add medium of instruction which is below subjects.</span>
      <form [formGroup]="edu_form"  class="step-container">
        <div class="row">
          <div class="col-md-3">Course Name : </div>
          <div class="col-md-4"> 
            <!--<input  ngModel="{{edu_data?.CourseName}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.courseNameCtrl.invalid && (edu_form.controls.courseNameCtrl.dirty || edu_form.controls.courseNameCtrl.touched)}" formControlName="courseNameCtrl" placeholder="" id="" class="form-control">-->
            <mat-form-field >
              <mat-select ngModel="{{edu_data?.CourseName}}" name="coursename" formControlName="courseNameCtrl">
                  <mat-option value="{{course.CourseShortForm}}" *ngFor="let course of course_data">{{course.CourseName}}</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="courseValidation===false" style="color:red;">Please select College Year.</span>  
          </div>
          <div class="col-md-3" *ngIf="admin_show == 'true'">Total Hours : </div>
          <div class="col-md-2" *ngIf="admin_show == 'true'">
            <input  ngModel="{{edu_data?.total_weeks}}" nbInput type="text" formControlName="totalweeksCtrl" placeholder="" id="" class="form-control"> 
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">College Year : </div>
          <div class="col-md-2">
            <mat-form-field id="selectLine" >
              <mat-select ngModel="{{edu_data?.CollegeYear}}" name="collegeYear" formControlName="collegeYearCtrl">
                  <mat-option value="First">First</mat-option>
                  <mat-option value="Second">Second</mat-option>
                  <mat-option value="Third">Third</mat-option>
                  <mat-option value="Fourth">Fourth</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="collegeYearValidation===false" style="color:red;">Please select College Year.</span> 
          </div>
          <div class="col-md-3">Class Obtained : </div>
          <div class="col-md-2">
              <mat-form-field id="selectLine" >
                  <mat-select ngModel="{{edu_data?.overall_class}}" name="overall_class" formControlName="overallclassCtrl">
                      <mat-option value="First">First</mat-option>
                      <mat-option value="Second">Second</mat-option>
                      <mat-option value="Third">Third</mat-option>
                      <mat-option value="Pass">Pass</mat-option>
                      <mat-option value="Passes">Passes</mat-option>
                      <mat-option value="Distinction">Distinction</mat-option>
                      <mat-option value = ''>NONE</mat-option>
                  </mat-select>
              </mat-form-field>
              <span *ngIf="classValidation===false" style="color:red;">Please select class</span> 
          </div>
      </div>
      <div class="row">
          <div class="col-md-3">Month : </div>
          <div class="col-md-2">
            <mat-form-field id="selectLine" >
              <mat-select  ngModel="{{edu_data?.Month}}" name="month" formControlName="monthCtrl">
                  <mat-option value="January">January</mat-option>
                  <mat-option value="February">February</mat-option>
                  <mat-option value="March">March</mat-option>
                  <mat-option value="April">April</mat-option>
                  <mat-option value="May">May</mat-option>
                  <mat-option value="June">June</mat-option>
                  <mat-option value="July">July</mat-option>
                  <mat-option value="August">August</mat-option>
                  <mat-option value="September">September</mat-option>
                  <mat-option value="October">October</mat-option>
                  <mat-option value="November">November</mat-option>
                  <mat-option value="December">December</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="monthValidation===false" style="color:red;">Please select month</span> 
          </div>
          <div class="col-md-3">Year : </div>
          <div class="col-md-2">
              <mat-form-field id="selectLine" >
                  <mat-select ngModel="{{edu_data?.Year}}" name="year" formControlName="yearCtrl">
                      <mat-option value="{{years}}" *ngFor="let years of years_array">{{years}}</mat-option>
                  </mat-select>
              </mat-form-field>
              <span *ngIf="yearValidation===false" style="color:red;">Please select year.</span> 
          </div>
      </div>
      <marquee *ngIf="admin_show == 'false'"><u><b style="color:red; font-size: 100%;">If you don't find your subject code or subject name under the drop down list, kindly do not select an incorrect option instead connect with our support team.</b></u></marquee>
      <div class="row">
        <div class="col-md-1">Subject 1 :</div>
        <div class="col-md-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput  type="text" [value]="filterText2 ? filterText2 : edu_data?.Subject_First" 
            [formControl]="filterInput2" 
            [matAutocomplete]="phdauto2" [matAutocompleteDisabled]="autocheck" (change)='getSubject($event)' ></textarea>
          </mat-form-field> 

          <mat-autocomplete #phdauto2="matAutocomplete"  >
              <mat-option style="width:800% !important;  " *ngFor="let college2 of course_code2 | filter: {Course_Subject_name : filterText2}" [value]="college2.Course_Subject_name" (click)="getCourse(college2)">
                  {{ college2.Course_Subject_name }}
              </mat-option>
          </mat-autocomplete>
          <!-- <input  ngModel="{{edu_data?.Subject_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFirstCtrl.invalid && (edu_form.controls.subjectFirstCtrl.dirty || edu_form.controls.subjectFirstCtrl.touched)}" formControlName="subjectFirstCtrl" placeholder="name" id="" class="form-control"> -->
        </div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.marks_obt_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstCtrl.invalid && (edu_form.controls.markFirstCtrl.dirty || edu_form.controls.markFirstCtrl.touched)}" formControlName="markFirstCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstOutCtrl.invalid && (edu_form.controls.markFirstOutCtrl.dirty || edu_form.controls.markFirstOutCtrl.touched)}" formControlName="markFirstOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-1" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstOutCtrl.invalid && (edu_form.controls.markFirstOutCtrl.dirty || edu_form.controls.markFirstOutCtrl.touched)}" formControlName="markFirstOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.practical_hour_First}}" nbInput type="text" formControlName="practicalhourFirstCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.lecture_hour_First}}" nbInput type="text" formControlName="lecturehourFirstCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.months_taken_First}}" nbInput type="text"  formControlName="monthstakenCtrl" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <div class="row">
        <div class="col-md-1">Subject 2 :</div>
        <div class="col-md-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput  type="text"   [value]="filterText ? filterText : edu_data?.Subject_Second"
              [matAutocomplete]="phdauto" [formControl]="filterInput" [matAutocompleteDisabled]="autocheck" (change)='getSubject2($event)' ></textarea>
          </mat-form-field> 
          
          <mat-autocomplete #phdauto="matAutocomplete"  style="width:200% !important;  ">
            <mat-option style="width:800% !important;  " *ngFor="let college of course_code | filter: {Course_Subject_name : filterText}" [value]="college.Course_Subject_name" (click)="getCourse2(college)">
              {{ college.Course_Subject_name }}
            </mat-option>
          </mat-autocomplete>
          <!-- <input  ngModel="{{edu_data?.Subject_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectSecondCtrl.invalid && (edu_form.controls.subjectSecondCtrl.dirty || edu_form.controls.subjectSecondCtrl.touched)}" formControlName="subjectSecondCtrl" placeholder="name" id="" class="form-control"> -->
        </div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.marks_obt_Second}}" nbInput type="text" formControlName="markSecondCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Second}}" nbInput type="text"  formControlName="markSecondOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-1" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Second}}" nbInput type="text"  formControlName="markSecondOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.practical_hour_Second}}" nbInput type="text" formControlName="practicalhourSecondCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.lecture_hour_Second}}" nbInput type="text" formControlName="lecturehourSecondCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.months_taken_Second}}" nbInput type="text"  formControlName="monthstakenCtrl2" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <div class="row">
        <div class="col-md-1">Subject 3 :</div>
        <div class="col-md-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput  type="text" [value]="filterText3 ? filterText3 : edu_data?.Subject_Third"
            [formControl]="filterInput3"   [matAutocomplete]="phdauto3" [matAutocompleteDisabled]="autocheck" (change)='getSubject3($event)' ></textarea>
          </mat-form-field> 

          <mat-autocomplete #phdauto3="matAutocomplete"  style="width:200% !important;  ">
              <mat-option style="width:800% !important;  " *ngFor="let college of course_code3 | filter: {Course_Subject_name : filterText3}" [value]="college.Course_Subject_name" (click)="getCourse3(college)">
                  {{ college.Course_Subject_name }}
              </mat-option>
          </mat-autocomplete>
          <!-- <input  ngModel="{{edu_data?.Subject_Third}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectThirdCtrl.invalid && (edu_form.controls.subjectThirdCtrl.dirty || edu_form.controls.subjectThirdCtrl.touched)}" formControlName="subjectThirdCtrl" placeholder="name" id="" class="form-control"> --> 
        </div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.marks_obt_Third}}" nbInput type="text"  formControlName="markThirdCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Third}}" nbInput type="text"  formControlName="markThirdOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-1" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Third}}" nbInput type="text" formControlName="markThirdOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.practical_hour_Third}}" nbInput type="text" formControlName="practicalhourThirdCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'" ngModel="{{edu_data?.lecture_hour_Third}}" nbInput type="text" formControlName="lecturehourThirdCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.months_taken_Third}}" nbInput type="text"  formControlName="monthstakenCtrl3" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <div class="row">
        <div class="col-md-1">Subject 4 :</div>
        <div class="col-md-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput  type="text" [value]="filterText4 ? filterText4 : edu_data?.Subject_Fourth"
            [formControl]="filterInput4"   [matAutocomplete]="phdauto4" [matAutocompleteDisabled]="autocheck" (change)='getSubject4($event)' ></textarea>
          </mat-form-field> 

          <mat-autocomplete #phdauto4="matAutocomplete"  style="width:200% !important;  ">
              <mat-option style="width:800% !important;  " *ngFor="let college of course_code4 | filter: {Course_Subject_name : filterText4}" [value]="college.Course_Subject_name" (click)="getCourse4(college)">
                  {{ college.Course_Subject_name }}
              </mat-option>
          </mat-autocomplete>
          <!-- <input  ngModel="{{edu_data?.Subject_Fourth}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFourthCtrl.invalid && (edu_form.controls.subjectFourthCtrl.dirty || edu_form.controls.subjectFourthCtrl.touched)}" formControlName="subjectFourthCtrl" placeholder="name" id="" class="form-control"> -->
        </div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.marks_obt_Fourth}}" nbInput type="text" formControlName="markFourthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show != 'true'"  ngModel="{{edu_data?.marks_out_Fourth}}" nbInput type="text"  formControlName="markFourthOutCtrl" placeholder="Out of" id="" (change)="totalsMarksOut()" class="form-control"></div>
        <div class="col-md-1"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.marks_out_Fourth}}" nbInput type="text" formControlName="markFourthOutCtrl" placeholder="Out of" id="" (change)="totalsMarksOut()" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.practical_hour_Fourth}}" nbInput type="text" formControlName="practicalhourFourthCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.lecture_hour_Fourth}}" nbInput type="text" formControlName="lecturehourFourthCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.months_taken_Fourth}}" nbInput type="text"  formControlName="monthstakenCtrl4" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <div class="row">
        <div class="col-md-1">Subject 5 :</div>
        <div class="col-md-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput  type="text" [value]="filterText5 ? filterText5 : edu_data?.Subject_Fifth"
            [formControl]="filterInput5"   [matAutocomplete]="phdauto5" [matAutocompleteDisabled]="autocheck" (change)='getSubject5($event)' ></textarea>
          </mat-form-field> 

          <mat-autocomplete #phdauto5="matAutocomplete"  style="width:200% !important;  ">
              <mat-option style="width:800% !important;  " *ngFor="let college of course_code5 | filter: {Course_Subject_name : filterText5}" [value]="college.Course_Subject_name" (click)="getCourse5(college)">
                  {{ college.Course_Subject_name }}
              </mat-option>
          </mat-autocomplete>
          <!-- <input  ngModel="{{edu_data?.Subject_Fifth}}" nbInput type="text"  formControlName="subjectFifthCtrl" placeholder="name" id="" class="form-control"> -->
        </div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.marks_obt_Fifth}}" nbInput type="text" formControlName="markFifthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show != 'true'" ngModel="{{edu_data?.marks_out_Fifth}}" nbInput type="text" formControlName="markFifthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-1"><input *ngIf="admin_show == 'true'" ngModel="{{edu_data?.marks_out_Fifth}}" nbInput type="text" formControlName="markFifthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.practical_hour_Fifth}}" nbInput type="text" formControlName="practicalhourFifthCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.lecture_hour_Fifth}}" nbInput type="text" formControlName="lecturehourFifthCtrl" placeholder="Lectures per Week" id="" class="form-control"></div> 
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.months_taken_Fifth}}" nbInput type="text"  formControlName="monthstakenCtrl5" placeholder="months taken" id="" class="form-control"></div>
        </div>
      <div class="row">
        <div class="col-md-1">Subject 6 :</div>
        <div class="col-md-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput  type="text" [value]="filterText6 ? filterText6 : edu_data?.Subject_Six"
            [formControl]="filterInput6"   [matAutocomplete]="phdauto6" [matAutocompleteDisabled]="autocheck" (change)='getSubject6($event)' ></textarea>
          </mat-form-field> 

          <mat-autocomplete #phdauto6="matAutocomplete"  style="width:200% !important;  ">
              <mat-option style="width:800% !important;  " *ngFor="let college of course_code6 | filter: {Course_Subject_name : filterText6}" [value]="college.Course_Subject_name" (click)="getCourse6(college)">
                  {{ college.Course_Subject_name }}
              </mat-option>
          </mat-autocomplete>
          <!-- <input  ngModel="{{edu_data?.Subject_Six}}" nbInput type="text"  formControlName="subjectSixthCtrl" placeholder="name" id="" class="form-control"> -->
        </div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.marks_obt_Six}}" nbInput type="text" formControlName="markSixthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show != 'true'" ngModel="{{edu_data?.marks_out_Six}}" nbInput type="text" formControlName="markSixthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-1"><input *ngIf="admin_show == 'true'" ngModel="{{edu_data?.marks_out_Six}}" nbInput type="text" formControlName="markSixthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.practical_hour_Six}}" nbInput type="text" formControlName="practicalhourSixCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.lecture_hour_Six}}" nbInput type="text" formControlName="lecturehourSixCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.months_taken_Six}}" nbInput type="text"  formControlName="monthstakenCtrl6" placeholder="months taken" id="" class="form-control"></div>
        </div>
      <div class="row">
        <div class="col-md-1">Subject 7 :</div>
        <div class="col-md-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput  type="text" [value]="filterText7 ? filterText7 : edu_data?.Subject_Seventh"
            [formControl]="filterInput7"   [matAutocomplete]="phdauto7" [matAutocompleteDisabled]="autocheck" (change)='getSubject7($event)' ></textarea>
          </mat-form-field> 

          <mat-autocomplete #phdauto7="matAutocomplete"  style="width:200% !important;  ">
              <mat-option style="width:800% !important;  " *ngFor="let college of course_code7 | filter: {Course_Subject_name : filterText7}" [value]="college.Course_Subject_name" (click)="getCourse7(college)">
                  {{ college.Course_Subject_name }}
              </mat-option>
          </mat-autocomplete>
          <!-- <input  ngModel="{{edu_data?.Subject_Seventh}}" nbInput type="text"  formControlName="subjectSeventhCtrl" placeholder="name" id="" class="form-control"> -->
        </div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.marks_obt_Seventh}}" nbInput type="text" formControlName="markSeventhCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show != 'true'"   ngModel="{{edu_data?.marks_out_Seventh}}" nbInput type="text" formControlName="markSeventhOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-1"><input *ngIf="admin_show == 'true'"   ngModel="{{edu_data?.marks_out_Seventh}}" nbInput type="text" formControlName="markSeventhOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.practical_hour_Seventh}}" nbInput type="text" formControlName="practicalhourSeventhCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.lecture_hour_Seventh}}" nbInput type="text" formControlName="lecturehourSeventhCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.months_taken_Seventh}}" nbInput type="text"  formControlName="monthstakenCtrl7" placeholder="months taken" id="" class="form-control"></div>

      </div>
      <div class="row">
        <div class="col-md-1">Subject 8 :</div>
        <div class="col-md-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput  type="text" [value]="filterText8 ? filterText8 : edu_data?.Subject_Eighth"
            [formControl]="filterInput8"   [matAutocomplete]="phdauto8" [matAutocompleteDisabled]="autocheck" (change)='getSubject8($event)' ></textarea>
          </mat-form-field> 

          <mat-autocomplete #phdauto8="matAutocomplete"  style="width:200% !important;  ">
              <mat-option style="width:800% !important;  " *ngFor="let college of course_code8 | filter: {Course_Subject_name : filterText8}" [value]="college.Course_Subject_name" (click)="getCourse8(college)">
                  {{ college.Course_Subject_name }}
              </mat-option>
          </mat-autocomplete>
          <!-- <input  ngModel="{{edu_data?.Subject_Eighth}}" nbInput type="text"  formControlName="subjectEighthCtrl" placeholder="name" id="" class="form-control"> -->
        </div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.marks_obt_Eighth}}" nbInput type="text" formControlName="markEighthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show != 'true'" ngModel="{{edu_data?.marks_out_Eighth}}" nbInput type="text" formControlName="markEighthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-1"><input *ngIf="admin_show == 'true'" ngModel="{{edu_data?.marks_out_Eighth}}" nbInput type="text" formControlName="markEighthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'"  ngModel="{{edu_data?.practical_hour_Eighth}}" nbInput type="text" formControlName="practicalhourEighthCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
        <div class="col-md-2"><input *ngIf="admin_show == 'true'" ngModel="{{edu_data?.lecture_hour_Eighth}}" nbInput type="text" formControlName="lecturehourEighthCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.months_taken_Eighth}}" nbInput type="text"  formControlName="monthstakenCtrl8" placeholder="months taken" id="" class="form-control"></div>


      </div>
      <br>
      <div class="row">
          <div class="col-md-3">Total obtained marks : </div>
          <div class="col-md-2">
            <input  ngModel="{{totalMarks ? totalMarks : edu_data?.overall_marks_obt}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.overmarksobtCtrl.invalid && (edu_form.controls.overmarksobtCtrl.dirty || edu_form.controls.overmarksobtCtrl.touched)}" formControlName="overmarksobtCtrl" placeholder="" id="" class="form-control"> 
          </div>
          <div class="col-md-3">Out of : </div>
          <div class="col-md-2">
            <input  ngModel="{{totalMarksOut ? totalMarksOut : edu_data?.overall_marks_out}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.overmarksoutCtrl.invalid && (edu_form.controls.overmarksoutCtrl.dirty || edu_form.controls.overmarksoutCtrl.touched)}" formControlName="overmarksoutCtrl" placeholder="" id="" class="form-control"> 
          </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-3">Percentage : </div>
        <div class="col-md-3"> <input  ngModel="{{parcen ? parcen : edu_data?.overAllYearlyGrade}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.percentageCtrl.invalid && (edu_form.controls.percentageCtrl.dirty || edu_form.controls.percentageCtrl.touched)}" formControlName="percentageCtrl" placeholder="enter percentage" id="" class="form-control"> </div>
        
      </div>
      <br>
      <div class="row">
        <div class="col-md-3">Medium of instruction : </div>
        <div class="col-md-3"> <input  [ngModel]="edu_data ? edu_data?.medium_instruction : 'English' " nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.instructionCtrl.invalid && (edu_form.controls.instructionCtrl.dirty || edu_form.controls.instructionCtrl.touched)}" formControlName="instructionCtrl" placeholder="" id="" class="form-control"> </div>
        <div class="col-md-3" *ngIf="admin_show == 'true'">Special Instruction : </div>
        <div class="col-md-3" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.special_instruction}}" nbInput type="text" formControlName="specialInstrctionCtrl" placeholder="" id="" class="form-control"> </div>          
      </div>
      </form>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton hero status="primary" (click)="dismiss()">Close</button> 
        <button *ngIf="amount_paid == 'false'" nbButton status="info" (click)="saveEdu()">save</button>
    </nb-card-footer>
</nb-card>
<p-confirmDialog [style]="{width: '425px'}"></p-confirmDialog>
  `,
  providers: [ ConfirmationService]
})
export class educationalformyearlyBcom implements OnInit {
  FeedbackForm : FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid:string;
  @Input() admin_show:string;
  @Input() course_name_auto : string;

  validations_flag = false;
  feedback_message ;
  showExperience = false;

  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  classValidation  = true;
  monthValidation  = true;
  yearValidation = true;
  attemptValidation  = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;
  totalMarks: number;
  totalMarksOut: number;
  parcen: number;
  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7= new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  course_code: any;
  course_code8: any;
  course_code2:  any;
  course_code3: any;
  course_code4:  any;
  course_code5: any;
  course_code6:  any;
  course_code7: any;
  course_code9:  any;
  course_code10: any;
  public filterText: any;
  public filterText2: any;
  filterText3 : any
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  autocheck = true;
  newcourse_code = [];

  constructor(protected api : ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<educationalformyearlyBcom>) { }

  async ngOnInit() {
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: [ '' ,  Validators.required],
      collegeYearCtrl : [ '' ,  Validators.required],
      overallclassCtrl : [ '' ,  Validators.required],
      monthCtrl : [ '' ,  Validators.required],
      yearCtrl : [ '' ,  Validators.required],
      overmarksobtCtrl : [ '' ,  Validators.required],
      overmarksoutCtrl : [ '' ,  Validators.required],
      subjectFirstCtrl : [ '' ],
      markFirstCtrl : [ '' ,  Validators.required],
      markFirstOutCtrl : [ '' ,  Validators.required],
      subjectSecondCtrl : [ ''],
      markSecondCtrl : [ ''],
      markSecondOutCtrl : [ '' ],
      subjectThirdCtrl : [ '' ],
      markThirdCtrl : [ '' ],
      markThirdOutCtrl : [ '' ],
      subjectFourthCtrl : [ '' ],
      markFourthCtrl : [ '' ],
      markFourthOutCtrl : [ '' ],
      subjectFifthCtrl : [ ''],
      markFifthCtrl : [ '' ],
      markFifthOutCtrl : [ '' ],
      subjectSixthCtrl : [ '' ],
      markSixthCtrl : [ ''],
      markSixthOutCtrl : [ ''],
      subjectSeventhCtrl : [ ''],
      markSeventhCtrl : [ ''],
      markSeventhOutCtrl : [ ''],
      subjectEighthCtrl : [ ''],
      markEighthCtrl : [ ''],
      markEighthOutCtrl: [ ''],
      instructionCtrl : [ '' ,  Validators.required],
      lecturehourFirstCtrl : [ ''],
      lecturehourSecondCtrl : [ ''],
      lecturehourThirdCtrl : [ ''],
      lecturehourFourthCtrl : [ ''],
      lecturehourFifthCtrl : [ ''],
      lecturehourSixCtrl : [ ''],
      lecturehourSeventhCtrl : [ ''],
      lecturehourEighthCtrl : [ ''],
      practicalhourFirstCtrl : [ ''],
      practicalhourSecondCtrl : [ ''],
      practicalhourThirdCtrl : [ ''],
      practicalhourFourthCtrl : [ ''],
      practicalhourFifthCtrl : [ ''],
      practicalhourSixCtrl : [ ''],
      practicalhourSeventhCtrl : [ ''],
      practicalhourEighthCtrl : [ ''],
      specialInstrctionCtrl: [ ''],
      totalweeksCtrl : [ ''],
      monthstakenCtrl : [ '' ],
      monthstakenCtrl2 : [ ''],
      monthstakenCtrl3: [ '' ],
      monthstakenCtrl4: [ '' ],
      monthstakenCtrl5: [ '' ],
      monthstakenCtrl6: [ ''],
      monthstakenCtrl7: [ ''],
      monthstakenCtrl8: [ '' ],
      percentageCtrl: [ '' ,  Validators.required],
    })

    this.api.getCouses()
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.course_data = data['data'];
           
          }else{

          }
    });


    this.api.getCouseCode('year',this.course_name_auto,null, null).subscribe((data: any) => {
            if (data["status"] == 200) {
              
              this.autocheck = false;
              this.filterText = "";
              this.course_code = data["data"];
              this.filterInput.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText = term;
              });
              
              // this.autocheck = false;
              this.filterText2 = "";
              this.course_code2 = data["data"];
              this.filterInput2.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText2 = term;
              });

              // this.autocheck = false;
              this.filterText3 = "";
              this.course_code3 = data["data"];
              this.filterInput3.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText3 = term;
              });
              
              // this.autocheck = false;
              this.filterText4 = "";
              this.course_code4 = data["data"];
              this.filterInput4.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText4 = term;
              });

              // this.autocheck = false;
              this.filterText5 = "";
              this.course_code5 = data["data"];
              this.filterInput5.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText5 = term;
              });

              // this.autocheck = false;
              this.filterText6 = "";
              this.course_code6 = data["data"];
              this.filterInput6.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText6 = term;
              });

              // this.autocheck = false;
              this.filterText7 = "";
              this.course_code7 = data["data"];
              this.filterInput7.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText7 = term;
              });

              // this.autocheck = false;
              this.filterText8 = "";
              this.course_code8 = data["data"];
              this.filterInput8.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText8 = term;
              });

              // this.autocheck = false;
              this.filterText9 = "";
              this.course_code9 = data["data"];
              this.filterInput9.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText9 = term;
              });

              // this.autocheck = false;
              this.filterText10 = "";
              this.course_code10 = data["data"];
              this.filterInput10.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText10 = term;
              });

              
      
              
            } else {
            }
          });
        
    

 



    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    
    
    if(this.user_id != null){
      this.api.getEducation(this.edu_id,this.user_id)
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.edu_data = data['data'];
           
          }else{
            
          }
      });
    }
  }

  getCourse(value){
    
    //this.filterText = "";
    this.subjectName = value

    var count = 0
    this.newcourse_code = [];
    this.course_code.forEach(element => {
      count++
      if(element['id'] == this.subjectName['id']){
        
      }else{
        
        this.newcourse_code.push(element)

       
      }

      if(count == this.course_code.length){
        this.course_code = this.newcourse_code
      }
    })
    // if(value.prac == 'yes'){
    
    //   this.prac_hour1 = value.Lec_per_Week
    //   this.lec_per_week1 = '-'
    // }else{
    //   this.lec_per_week1 = value.Lec_per_Week
    //   this.prac_hour1 = '-'
    
    // }
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event : any){
    
    this.withoutCodeSub = event.target.value
    if(this.subjectName){
      
    }else{
      
    }
  }

  getCourse2(value){
    
    //this.filterText = "";
    this.subjectName2 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code3.forEach(element => {
      count++
      if(element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id']){
        
      }else{
        
        this.newcourse_code.push(element)

       
      }

      if(count == this.course_code3.length){
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code
      }
    })
  }

  getSubject2(event : any){
    
    this.withoutCodeSub2 = event.target.value
    
  }

  getCourse3(value){
    this.subjectName3 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code4.forEach(element => {
      count++
      if(element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id']){
        
      }else{
        
        this.newcourse_code.push(element)

       
      }

      if(count == this.course_code4.length){
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code
      }
    })
  }

  getSubject3(event : any){
    this.withoutCodeSub3 = event.target.value  
  }

  getCourse4(value){
    
    this.subjectName4 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code5.forEach(element => {
      count++
      if(element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id']){
        
      }else{
        
        this.newcourse_code.push(element)

       
      }

      if(count == this.course_code5.length){
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code
      }
    })
  }

  getSubject4(event : any){
    
    this.withoutCodeSub4 = event.target.value
    
  }

  getCourse5(value){
    
    this.subjectName5 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code6.forEach(element => {
      count++
      if(element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id']){
        
      }else{
        
        this.newcourse_code.push(element)

       
      }

      if(count == this.course_code6.length){
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code
      }
    })
  }

  getSubject5(event : any){
    
    this.withoutCodeSub5 = event.target.value
    
  }

  getCourse6(value){
   
    this.subjectName6 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code7.forEach(element => {
      count++
      if(element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id']){
        
      }else{
        
        this.newcourse_code.push(element)

       
      }

      if(count == this.course_code7.length){
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code
      }
    })
  }

  getSubject6(event : any){
    
    this.withoutCodeSub6 = event.target.value
    
  }

  getCourse7(value){
    
    this.subjectName7 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code8.forEach(element => {
      count++
      if(element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id'] || element['id'] == this.subjectName7['id']){
        
      }else{
        
        this.newcourse_code.push(element)

       
      }

      if(count == this.course_code8.length){
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code
      }
    })
  }

  getSubject8(event : any){
    
    this.withoutCodeSub8 = event.target.value
    
  }
  getCourse8(value){
    
    this.subjectName8 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour8 = value.Lec_per_Week
    //   this.lec_per_week8 = '-'
    // }else{
    //   this.lec_per_week8 = value.Lec_per_Week
    //   this.prac_hour8 = '-'
    
    // }
  }
  getSubject9(event : any){
    
    this.withoutCodeSub9 = event.target.value
    
  }
  getCourse10(value){
    
    this.subjectName10 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour10 = value.Lec_per_Week
    //   this.lec_per_week10 = '-'
    // }else{
    //   this.lec_per_week10 = value.Lec_per_Week
    //   this.prac_hour10 = '-'
    
    // }
  }

  getSubject10(event : any){
    
    this.withoutCodeSub10 = event.target.value
    
  }
  getCourse9(value){
    
    this.subjectName9 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour9 = value.Lec_per_Week
    //   this.lec_per_week9 = '-'
    // }else{
    //   this.lec_per_week9 = value.Lec_per_Week
    //   this.prac_hour9 = '-'
    
    // }
  }

  getSubject7(event : any){
    
    this.withoutCodeSub7 = event.target.value
    
  }

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.classValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;

    if (this.edu_form.valid==false){
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overmarksoutCtrl.markAsDirty();
      this.edu_form.controls.overmarksobtCtrl.markAsDirty();
      //this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();
      this.edu_form.controls.percentageCtrl.markAsDirty();

      if(this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value ==='' || this.edu_form.controls.instructionCtrl.value ===undefined){
        this.instructionValidation = false;
      }else {
        this.instructionValidation = true;
      }

      if(this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value ==='' || this.edu_form.controls.courseNameCtrl.value ===undefined){
        this.courseValidation = false;
      }else {
        this.courseValidation = true;
      }
      
      if(this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value ==='' || this.edu_form.controls.collegeYearCtrl.value ===undefined){
        this.collegeYearValidation = false;
      }else {
        this.collegeYearValidation = true;
      }

      if(this.edu_form.controls.overallclassCtrl.value === null || this.edu_form.controls.overallclassCtrl.value ==='' || this.edu_form.controls.overallclassCtrl.value ===undefined){
        this.classValidation = false;
      }else {
        this.classValidation = true;
      }

      if(this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value ==='' || this.edu_form.controls.monthCtrl.value ===undefined){
        this.monthValidation = false;
      }else {
        this.monthValidation = true;
      }

      if(this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value ==='' || this.edu_form.controls.yearCtrl.value ===undefined){
        this.yearValidation = false;
      }else {
        this.yearValidation = true;
      }
    }else{
      var edu_data ={
        courseName : this.edu_form.controls.courseNameCtrl.value,
        collegeYear : this.edu_form.controls.collegeYearCtrl.value,
        overall_class: this.edu_form.controls.overallclassCtrl.value,
        month : this.edu_form.controls.monthCtrl.value,
        year : this.edu_form.controls.yearCtrl.value,
        overall_marks_obt : this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out : this.edu_form.controls.overmarksoutCtrl.value,
        //subjectFirst : this.edu_form.controls.subjectFirstCtrl.value,
        subjectFirst : this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub,
        marks_obt_First : this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        //subjectSecond : this.edu_form.controls.subjectSecondCtrl.value,
        subjectSecond : this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        //subjectThird : this.edu_form.controls.subjectThirdCtrl.value,
        subjectThird : this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        marks_obt_Third : this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third : this.edu_form.controls.markThirdOutCtrl.value,
        //subjectFourth : this.edu_form.controls.subjectFourthCtrl.value,
        subjectFourth : this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        marks_obt_Fourth : this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth : this.edu_form.controls.markFourthOutCtrl.value,
        //subjectFifth : this.edu_form.controls.subjectFifthCtrl.value,
        subjectFifth : this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        marks_obt_Fifth : this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth : this.edu_form.controls.markFifthOutCtrl.value,
        //subjectSixth : this.edu_form.controls.subjectSixthCtrl.value,
        subjectSixth :this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        marks_obt_Six : this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six : this.edu_form.controls.markSixthOutCtrl.value,
        //subjectSeventh : this.edu_form.controls.subjectSeventhCtrl.value,
        subjectSeventh :this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        marks_obt_Seventh : this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh : this.edu_form.controls.markSeventhOutCtrl.value,
        //subjectEighth : this.edu_form.controls.subjectEighthCtrl.value,
        subjectEighth :  this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        marks_obt_Eighth : this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth : this.edu_form.controls.markEighthOutCtrl.value,
        user_id : this.user_id,
        medium_instruction : this.edu_form.controls.instructionCtrl.value,
        id : this.edu_id,
        // lecture_hour_First : this.edu_form.controls.lecturehourFirstCtrl.value,
        // lecture_hour_Second : this.edu_form.controls.lecturehourSecondCtrl.value,
        // lecture_hour_Third : this.edu_form.controls.lecturehourThirdCtrl.value,
        // lecture_hour_Fourth : this.edu_form.controls.lecturehourFourthCtrl.value,
        // lecture_hour_Fifth : this.edu_form.controls.lecturehourFifthCtrl.value,
        // lecture_hour_Six : this.edu_form.controls.lecturehourSixCtrl.value,
        // lecture_hour_Seventh : this.edu_form.controls.lecturehourSeventhCtrl.value,
        // lecture_hour_Eighth : this.edu_form.controls.lecturehourEighthCtrl.value,
        lecture_hour_First  : this.subjectName ? this.subjectName['Lectures_per_Week'] : this.edu_form.controls.lecturehourFirstCtrl.value ,
        lecture_hour_Second  :this.subjectName2 ? this.subjectName2['Lectures_per_Week'] : this.edu_form.controls.lecturehourSecondCtrl.value,
        lecture_hour_Third  :this.subjectName3 ? this.subjectName3['Lectures_per_Week'] : this.edu_form.controls.lecturehourThirdCtrl.value,
        lecture_hour_Fourth  :this.subjectName4 ? this.subjectName4['Lectures_per_Week'] : this.edu_form.controls.lecturehourFourthCtrl.value,
        lecture_hour_Fifth  :this.subjectName5 ? this.subjectName5['Lectures_per_Week'] : this.edu_form.controls.lecturehourFifthCtrl.value,
        lecture_hour_Six  :this.subjectName6 ? this.subjectName6['Lectures_per_Week'] : this.edu_form.controls.lecturehourSixCtrl.value,
        lecture_hour_Seventh  :this.subjectName7 ? this.subjectName7['Lectures_per_Week'] : this.edu_form.controls.lecturehourSeventhCtrl.value,
        lecture_hour_Eighth  :this.subjectName8 ? this.subjectName8['Lectures_per_Week'] : this.edu_form.controls.lecturehourEighthCtrl.value,
        // practical_hour_First : this.edu_form.controls.practicalhourFirstCtrl.value,
        // practical_hour_First : this.edu_form.controls.practicalhourFirstCtrl.value,
        // practical_hour_Second : this.edu_form.controls.practicalhourSecondCtrl.value,
        // practical_hour_Third : this.edu_form.controls.practicalhourThirdCtrl.value,
        // practical_hour_Fourth : this.edu_form.controls.practicalhourFourthCtrl.value,
        // practical_hour_Fifth : this.edu_form.controls.practicalhourFifthCtrl.value,
        // practical_hour_Six : this.edu_form.controls.practicalhourSixCtrl.value,
        // practical_hour_Seventh : this.edu_form.controls.practicalhourSeventhCtrl.value,
        // practical_hour_Eighth : this.edu_form.controls.practicalhourEighthCtrl.value,
        practical_hour_First  : this.subjectName ? this.subjectName['Hours_and_Minutes_per_Week'] :  this.edu_form.controls.practicalhourFirstCtrl.value ,
        practical_hour_Second  : this.subjectName2 ? this.subjectName2['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourSecondCtrl.value,
        practical_hour_Third  : this.subjectName3 ? this.subjectName3['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourThirdCtrl.value,
        practical_hour_Fourth  : this.subjectName4 ? this.subjectName4['Hours_and_Minutes_per_Week'] :  this.edu_form.controls.practicalhourFourthCtrl.value,
        practical_hour_Fifth  :this.subjectName5 ? this.subjectName5['Hours_and_Minutes_per_Week'] :  this.edu_form.controls.practicalhourFifthCtrl.value,
        practical_hour_Six  :this.subjectName6 ? this.subjectName6['Hours_and_Minutes_per_Week'] :  this.edu_form.controls.practicalhourSixCtrl.value,
        practical_hour_Seventh  :this.subjectName7 ? this.subjectName7['Hours_and_Minutes_per_Week'] :  this.edu_form.controls.practicalhourSeventhCtrl.value,
        practical_hour_Eighth  :this.subjectName8 ? this.subjectName8['Hours_and_Minutes_per_Week'] :  this.edu_form.controls.practicalhourEighthCtrl.value,
        total_weeks : this.edu_form.controls.totalweeksCtrl.value,
        special_instruction : this.edu_form.controls.specialInstrctionCtrl.value,
        monthstakenCtrl  : this.subjectName ? (this.edu_form.controls.monthstakenCtrl.value ? this.edu_form.controls.monthstakenCtrl.value : '4' ) : '',
        monthstakenCtrl2  : this.subjectName2 ? (this.edu_form.controls.monthstakenCtrl2.value ? this.edu_form.controls.monthstakenCtrl2.value : '4') : '',
        monthstakenCtrl3  :this.subjectName3 ? (this.edu_form.controls.monthstakenCtrl3.value ?  this.edu_form.controls.monthstakenCtrl3.value: '4') : '',
        monthstakenCtrl4  :this.subjectName4 ? (this.edu_form.controls.monthstakenCtrl4.value ? this.edu_form.controls.monthstakenCtrl4.value : '4') : '',
        monthstakenCtrl5  :this.subjectName5 ? (this.edu_form.controls.monthstakenCtrl5.value ? this.edu_form.controls.monthstakenCtrl5.value : '4') : '',
        monthstakenCtrl6  :this.subjectName6 ? (this.edu_form.controls.monthstakenCtrl6.value ? this.edu_form.controls.monthstakenCtrl6.value : '4') : '',
        monthstakenCtrl7  :this.subjectName7 ? (this.edu_form.controls.monthstakenCtrl7.value ? this.edu_form.controls.monthstakenCtrl7.value : '4') : '',
        monthstakenCtrl8  :this.subjectName8 ? (this.edu_form.controls.monthstakenCtrl8.value ? this.edu_form.controls.monthstakenCtrl8.value : '4') : '',
        //semester: this.edu_form.controls.semesterCtrl.value,
        overAllYearlyGrade : this.edu_form.controls.percentageCtrl.value,

      }
  
      this.api.setEducationalValues(edu_data)
      .subscribe(
        (data: any) => {  
          this.ref.close(data);
          err => console.error(err) 
      });
    }
  }

  dismiss() {
    this.ref.close();
  }


  hetmarksObt(){
    this.totalMarks = 0
    
    if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '' && this.edu_form.controls.markEighthCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value) + Number(this.edu_form.controls.markEighthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) )
      
    }else if(this.edu_form.controls.markSecondCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markFirstCtrl.value))
      
    }
  }

 totalsMarksOut(){
   this.totalMarksOut = 0
   if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '' && this.edu_form.controls.markEighthOutCtrl.value){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value))
   }

   if(this.totalMarksOut != null && this.totalMarksOut != undefined && this.totalMarks != null &&  this.totalMarks != undefined){
    this.parcen =  (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
    this.parcen = Number(this.parcen.toFixed(2))
    
  }
 }

}